export const DataTypes = {
    Statistics: "statistics",
    Line_Chart: "line_chart",
    Bar_Chart: "bar_chart",
    Pie_Chart: "pie_chart",
    InfoMap: "info_map",
    Table: "table",
    Group: "group",
    List: "list",
    Custom: "custom"
}

export const OptionTypes = {
    Message_Create: "message_create",
    Array: "array",
    Color: "color",
    Boolean: "boolean",
    MultiLine_Text: "long_string",
    Text: "string",
    Number: "number",
    Enum: "enum",
    Advanced_Enum: "id_enum",
    Image: "image",
    Emoji: "emoji",
    Pair: "pair"
}